// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__PXSiK","datetime":"News_datetime__ko55i","source":"News_source__ozqHC"};